import type { JobStateName } from '@steado/admin-contract/jobs';

import type { ToneName } from '@/components/table/tone';

/**
 * One tone per job state, shared by the queue cards, the table and the drawer.
 * `Record<JobStateName, …>` rather than a loose lookup, so a state added to the
 * contract is a compile error here instead of a silently grey badge.
 */
export const JOB_STATE_TONES: Readonly<Record<JobStateName, ToneName>> = {
  waiting: 'mute',
  active: 'info',
  delayed: 'warn',
  failed: 'err',
  completed: 'ok',
};
